<template>
  <div id="gallery">
    <div class="container">
      <div class="row width_full">
        <div class="col_12">
          <div class="customer_content">
            <div class="common_subtitle pb_20">
              <h3 class="mb_0">Galleries</h3>
              <button class="btn btn_success" style="float: right" @click="openModal">Add New Gallery</button>
            </div>
            <div class="row">
              <div class="col_12">
                <table-component
                    :columns="columns"
                    :rows="galleries"
                    :header="true"
                    :centralized="true"
                    :sortable="sortable"
                    :pagination="pagination"
                    :searchShowStatus="true"
                    :perPageShowStatus="true"
                    @queryEvent="queryEvent"
                    @sorting="sorting"
                    @pageChanged="pageChanged">

                  <template v-slot:action="{ row }">
                    <router-link :to="{name:'gallery_view', params:{id:row.id}}" class="btn btn_info cursor_pointer mr_10" @click="editGallery(row)"> View</router-link>
                    <span  class="btn btn_success cursor_pointer" @click="editGallery(row)"> Edit</span>
                    <span class="ml_10 btn btn_danger cursor_pointer" @click.prevent="deleteRecord(row)">Delete</span>
                  </template>
                </table-component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-component
        v-if="showModal"
        :modal-size="'custom_modal_800p'"
        :header-classes="'display_table white_bg no_border pa15 pb_0'"
        :content-classes="'pl_15 pr_15'"
        @closeModal="closeModal"
    >
      <template #header>
        <span class="modal_header_title">{{ newForm ? 'New Gallery' :  form.name }}</span>
      </template>
      <template #content>
        <div class="row">
          <div class="col_12">
            <div :class="['form-group', {'has_error': errorFor('name')}]">
              <label>Name (Korean)</label>
              <input type="text" class="form_global" placeholder="Name Korean" v-model="form.name">
              <template v-if="errors && errors.name">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div :class="['form-group', {'has_error': errorFor('name_en')}]">
              <label>Name (English)</label>
              <input type="text" class="form_global" placeholder="Name English" v-model="form.name_en">
              <template v-if="errors && errors.name_en">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name_en" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div :class="['form-group', {'has_error': errorFor('description')}]">
              <label>Description</label>
              <textarea name="" id="" cols="30" rows="10" class="form_global" v-model="form.description"></textarea>
            </div>
            <div class="d_flex_end">
              <button class="btn btn_common" @click="submit()">Save</button>
            </div>
          </div>
        </div>
      </template>
    </modal-component>
  </div>
</template>

<script>
import TableComponent from "../../components/shared/TableComponent";
import ModalComponent from "../../components/shared/ModalComponent";
export default {
  name: "Index",
  components: {ModalComponent, TableComponent},
  data(){
    return {
      showModal:false,
      newForm: null,
      galleries: [],
      sort: '1',
      sortable: {
        order: 'id',
        sort: 'desc'
      },
      filter: {
        status: '',
        per_page: 10
      },
      columns: [
        {
          label: "Name",
          field: "name",
          sortable: true
        },
        {
          label: "Created Date",
          field: "created_at",
          sortable: false,
          slot: false,
        },
        {
          label: "Images",
          field: "images_count",
          sortable: false,
          slot: false,
        },

        {
          label: "Action",
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
      form:{
        name: '',
        status: 1,
        description: '',
      },
      pagination: null,
      queryParams: {
        page: 1,
        per_page: 10,
        search: '',
        search_columns: 'name',
        sort: '',
        sort_order: '',
      },
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    queryParams: {
      deep: true,
      handler() {
        this.loadData()
      }
    },
  },
  methods:{
    closeModal(){
      this.newForm = false
      this.showModal = false
    },
    openModal(){
      this.errors = []
      this.newForm = true
      this.resetForm()
      this.showModal = true
    },
    resetForm(){
      this.form.name = ''
      this.form.description = ''
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
    },
    pageChanged(page) {
      this.queryParams.page = page;
    },
    queryEvent(query){
      this.queryParams.search = query.search
      this.queryParams.per_page = query.per_page
    },
    loadData(){
      this.axios.get('/galleries', {
        params: {...this.queryParams}
      }).then((response) => {
        this.galleries = response.data.data;
        this.pagination = response.data.meta;
      })
    },
    editGallery(row){
      this.errors = []
      this.newForm = false
      this.resetForm()
      this.form = {...row}
      this.showModal = true
    },
    deleteRecord(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/galleries/'+row.id).then(() => {
            this.$swal.fire(
                'Deleted',
                'Gallery has been deleted!',
                'success'
            )
            this.loadData();
          });
        }
      });
    },
    submit() {
      this.errors = null;
      this.loading = true;
      if (this.newForm) {
        this.axios.post('/galleries', this.form)
            .then(() => {
              this.showModal = false;
              this.loadData();
              this.resetForm()
              this.showSuccessMsg("Added Successfully!");
              this.resetForm()
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      } else {
        this.axios.patch('/galleries/'+ this.form.id, this.form)
            .then(() => {
              this.closeModal()
              this.loadData();
              this.showSuccessMsg("Updated Successfully!");
              this.resetForm()
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      }

    },
  },
}
</script>
